export interface UserAgreementContent {
  content: string;
  publishedVersion: number;
  publishedAt: string;
}

/**
 * Fetches the user agreement content from the backend Netlify function
 * Returns the markdown content and version information
 */
export async function getUserAgreement(): Promise<UserAgreementContent> {
  try {
    const response = await fetch('/.netlify/functions/getUserAgreement');

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `Failed to fetch user agreement: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Failed to fetch user agreement:', error);
    throw error;
  }
}
